import { useAppState } from 'store/hooks/useAppState'

export const useVisStateKeplerState = (selectorFn) =>
  useAppState((state) => selectorFn(state.maplab?.keplerGl?.MapLab?.visState))
